import React from "react"
import { connect } from "react-redux"
import OpenOrderTitle from "../../components/shop/open-order-title"

const mapStateToProps = state => ({
  openOrder: state.entities.openOrders[state.currentShop.openOrders.currentId]
})

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch({type: "OPEN_ORDER.CLOSE_TITLE"})
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenOrderTitle)
